import { AllPostSaved } from "./all-post-saved";

const allRoute = [AllPostSaved()];

export default allRoute;
